import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/TreeLoader.tsx",
    _templateObject2;

import "core-js/modules/es.array.some.js";

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import * as React from 'react';
import styled from 'styled-components';
import { combine } from 'effector';
import { useStore } from 'effector-react';
import { LinearProgress as LinearProgressInit } from '@gmini/ui-kit/lib/LinearProgress';
import { Backdrop as BackdropInit } from '@gmini/ui-kit/lib/Backdrop';
import * as api from '@gmini/sm-api-sdk';
import { jsx as _jsx } from "react/jsx-runtime";
var Backdrop = styled(BackdropInit)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  && {\n    position: absolute;\n    z-index: 1201;\n    align-items: flex-start;\n    background-color: rgba(255, 255, 255, 0.7);\n  }\n"])));
var LinearProgress = styled(LinearProgressInit)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
export var operationsPending$ = combine({
  ɔ: [[api.UserClassifier.removeAll.defaultContext.pending$, api.UserClassifier.removeDependency.defaultContext.pending$, api.UserClassifier.createRefsFromExternalIds.defaultContext.pending$, api.UserClassifierGroup.createGroupReference.defaultContext.pending$, api.UserClassifierGroup.create.defaultContext.pending$, api.UserClassifierGroup.move.defaultContext.pending$, api.UserClassifierGroup.rename.defaultContext.pending$, api.UserClassifierGroup.remove.defaultContext.pending$, api.UserClassifierGroup.createFilter.defaultContext.pending$, api.UserClassifierGroup.updateFilter.defaultContext.pending$, api.UserClassifierGroup.removeFilter.defaultContext.pending$, api.BimReference.create.defaultContext.pending$, api.BimReference.move.defaultContext.pending$, api.BimReference.remove.defaultContext.pending$, api.BimReference.createRefs.defaultContext.pending$, api.BimReference.moveRefs.defaultContext.pending$], function (pendingList) {
    return pendingList.some(Boolean);
  }],
  config: {
    name: "operationsPending$",
    sid: "-vgkauy"
  }
});
export var TreeLoader = /*#__PURE__*/React.memo(function () {
  var loading = useStore(operationsPending$, {
    loc: {
      file: _effectorFileName,
      line: 47,
      column: 18
    },
    name: "TreeLoader",
    sid: "TreeLoader /src/classifier-editor/TreeLoader.tsx [47, 18]"
  });
  return /*#__PURE__*/_jsx(Backdrop, {
    open: loading,
    children: /*#__PURE__*/_jsx(LinearProgress, {})
  });
});
TreeLoader.displayName = 'TreeLoader';